module.exports = __webpack_public_path__ + "img/logo-text.59af3442.svg";